module.exports = __webpack_public_path__ + "static/media/Add.a70846ab.png";